import { serviceRouteConstants } from "@/Constants/routingConstants";

import { post } from ".";

export const _fetchFieldData = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.fieldData,
    data: data,
  };
  return await post(request);
};

export const _fetchCandidateDropdownData = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.candidateDropdownData,
    data: data,
  };
  return await post(request);
};
